import styled from 'styled-components';

export const ToggleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #333333;

  &:focus-within {
    transition: none;
    outline: 2px dotted #0669de;
    border-radius: 3px;
  }

  > label {
    :not(:empty) {
      margin-right: 8px;
    }
  }
`;

export const Switch = styled.div`
  position: relative;
  width: 44px;
  height: 24px;
  background: #333333;
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 35px;
    top: 50%;
    left: 4px;
    background: white;
    transform: translate(0, -50%);
  }
`;

export const Input = styled.input`
  opacity: 0.001;
  width: 100%;
  height: 100%;
  margin-left: 5px;
  position: absolute;
  z-index: 1;
  cursor: pointer;

  &:disabled {
    opacity: 0;
  }

  &:checked + ${Switch} {
    background: ${props => props.theme.colors?.primary.main.color};

    &:before {
      transform: translate(18px, -50%);
    }
  }
`;
